import React, { useRef } from "react";
import HCaptcha from "@hcaptcha/react-hcaptcha";

const SITE_KEY = process.env.REACT_APP_HCAPTCHA_SITE_KEY;

export default function Captcha({ onVerify, onExpire }) {
  const ref = useRef(null);
  if (!SITE_KEY) {
    return (
      <div className="p-3 rounded-lg bg-[#FF9F0A]/10 border border-[#FF9F0A]/30 text-[#FF9F0A] text-xs">
        Captcha not configured.
      </div>
    );
  }
  return (
    <div data-testid="captcha-widget" className="flex justify-center">
      <HCaptcha
        ref={ref}
        sitekey={SITE_KEY}
        theme="dark"
        onVerify={(token) => onVerify?.(token)}
        onExpire={() => onExpire?.()}
        onError={() => onExpire?.()}
      />
    </div>
  );
}
